function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["value", "className", "placeholder", "onDropdownVisibleChange", "showSearch", "filterOption", "optionFilterProp", "multiple", "options", "clearWhenOptionsUpdated", "preview"],
  _excluded2 = ["label", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useEffect, useState, useContext, useRef } from 'react';
import { Select } from 'antd';
import omit from 'omit.js';
import formMethods from "../utils/form-methods";
import { ArrowDownOutlined, ArrowUpOutlined, SearchOutlined } from 'iglooicon';
import classnames from 'classnames';
import Checkbox from "../checkbox";
import LocaleContext from "../locale/locale-context";
import Button from "../button";
import Input from "../input";
import "./style";
import { compareOptions, compareSelected, optionsHOC, previewSelectedOptions } from "../utils/option-utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IglooSelect = function IglooSelect(_ref) {
  var valueProp = _ref.value,
    className = _ref.className,
    placeholder = _ref.placeholder,
    _ref$onDropdownVisibl = _ref.onDropdownVisibleChange,
    onDropdownVisibleChange = _ref$onDropdownVisibl === void 0 ? function () {} : _ref$onDropdownVisibl,
    showSearch = _ref.showSearch,
    filterOption = _ref.filterOption,
    optionFilterProp = _ref.optionFilterProp,
    multiple = _ref.multiple,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$clearWhenOptions = _ref.clearWhenOptionsUpdated,
    clearWhenOptionsUpdated = _ref$clearWhenOptions === void 0 ? false : _ref$clearWhenOptions,
    preview = _ref.preview,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var _useState = useState(valueProp),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedOptions = _useState4[0],
    setSelectedOptions = _useState4[1];
  var _useState5 = useState(options),
    _useState6 = _slicedToArray(_useState5, 2),
    displayOptions = _useState6[0],
    setDisplay = _useState6[1];
  var originOptions = useRef(options);
  useEffect(function () {
    typeof rest.onChange === 'function' && compareSelected(selected, valueProp) && rest.onChange(selected, selectedOptions);
  }, [selected]);
  useEffect(function () {
    valueProp !== selected && setSelected(valueProp);
  }, [valueProp]);
  useEffect(function () {
    var setFieldValue = rest.setFieldValue;
    if (compareOptions(options, originOptions.current)) {
      if (clearWhenOptionsUpdated) {
        typeof setFieldValue === 'function' && setFieldValue();
      } else {
        var foundValue = options.find(function (option) {
          return Array.isArray(valueProp) ? valueProp.includes(option.value) : option.value === valueProp;
        });
        if (!foundValue && valueProp !== undefined) {
          typeof setFieldValue === 'function' && setFieldValue();
        }
      }
      setDisplay(options);
      originOptions.current = options;
    }
  }, [options]);
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    dropVisible = _useState8[0],
    setDropVisible = _useState8[1];
  var handleDropDownVisibleChange = function handleDropDownVisibleChange(open) {
    typeof onDropdownVisibleChange === 'function' && onDropdownVisibleChange(open);
    setDropVisible(open);
  };
  var handleSearch = function handleSearch(e) {
    var value = e.target.value;
    var filteredOptions = options.filter(function (option) {
      var _option$label, _option$label$toStrin;
      return Boolean(option === null || option === void 0 ? void 0 : (_option$label = option.label) === null || _option$label === void 0 ? void 0 : (_option$label$toStrin = _option$label.toString()) === null || _option$label$toStrin === void 0 ? void 0 : _option$label$toStrin.includes(value));
    });
    setDisplay(filteredOptions);
  };
  var selectAll = function selectAll() {
    var selectedArr = Array.from(new Set([].concat(_toConsumableArray(selected || []), _toConsumableArray(displayOptions.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    })))));
    setSelected(selectedArr);
    setSelectedOptions(options.filter(function (_ref3) {
      var value = _ref3.value;
      return selectedArr.includes(value);
    }));
  };
  var clearAll = function clearAll() {
    var selectedOptions = [];
    setSelected(function (selected) {
      return selected.filter(function (key) {
        if (!displayOptions.find(function (_ref4) {
          var value = _ref4.value;
          return value === key;
        })) {
          var option = options.find(function (_ref5) {
            var value = _ref5.value;
            return value === key;
          });
          selectedOptions.push(option);
          return true;
        }
        return false;
      });
    });
    setSelectedOptions(selectedOptions);
  };
  var handleChange = function handleChange(values, options) {
    setSelected(values);
    setSelectedOptions(options);
  };
  if (preview) return previewSelectedOptions(options, valueProp);
  return /*#__PURE__*/_jsx("div", {
    className: classnames('igloo-select', 'igloo-attached-select-containter', className),
    children: /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({
      placeholder: placeholder || formatMessage({
        id: 'Please select'
      }),
      getPopupContainer: function getPopupContainer(trigger) {
        return trigger.parentNode;
      }
    }, omit(rest, formMethods)), {}, {
      value: selected,
      suffixIcon: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ArrowDownOutlined, {
          className: classnames({
            'igloo-select-arrow': true,
            'igloo-select-arrow-active': dropVisible
          }),
          style: {
            opacity: dropVisible ? 0 : 1
          }
        }), /*#__PURE__*/_jsx(ArrowUpOutlined, {
          className: classnames({
            'igloo-select-arrow': true,
            'igloo-select-arrow-active': dropVisible
          }),
          style: {
            opacity: dropVisible ? 1 : 0
          }
        })]
      }),
      className: classnames('igloo-attached-select', {
        'igloo-attached-select-open-status': dropVisible
      }),
      onDropdownVisibleChange: handleDropDownVisibleChange,
      showSearch: showSearch && !multiple,
      filterOption: filterOption || (showSearch ? function (value, option) {
        var _option$label2, _option$label2$toStri;
        return Boolean(option === null || option === void 0 ? void 0 : (_option$label2 = option.label) === null || _option$label2 === void 0 ? void 0 : (_option$label2$toStri = _option$label2.toString()) === null || _option$label2$toStri === void 0 ? void 0 : _option$label2$toStri.includes(value));
      } : void 0),
      mode: multiple ? 'multiple' : void 0,
      showArrow: true,
      dropdownRender: function dropdownRender(originNode) {
        if (!multiple) {
          return originNode;
        }
        return /*#__PURE__*/_jsxs("div", {
          className: "igloo-attached-select-multiple-dropdown",
          children: [showSearch && /*#__PURE__*/_jsx("div", {
            style: {
              padding: '12px 16px'
            },
            children: /*#__PURE__*/_jsx(Input, {
              onChange: handleSearch,
              prefix: /*#__PURE__*/_jsx(SearchOutlined, {
                style: {
                  fontSize: 24
                }
              }),
              onKeyDown: function onKeyDown(e) {
                return e.stopPropagation();
              }
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "igloo-attached-select-multiple-dropdown-buttons",
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: selectAll,
              disabled: displayOptions.every(function (_ref6) {
                var value = _ref6.value;
                return selected === null || selected === void 0 ? void 0 : selected.includes(value);
              }),
              children: formatMessage({
                id: 'Select All'
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              onClick: clearAll,
              disabled: displayOptions.every(function (_ref7) {
                var value = _ref7.value;
                return !(selected !== null && selected !== void 0 && selected.includes(value));
              }),
              children: formatMessage({
                id: 'Clear All'
              })
            })]
          }), originNode]
        });
      },
      maxTagCount: 0,
      maxTagPlaceholder: function maxTagPlaceholder(values) {
        return values.map(function (_ref8) {
          var v = _ref8.value;
          var option = options.find(function (_ref9) {
            var value = _ref9.value;
            return value === v;
          });
          return option === null || option === void 0 ? void 0 : option.label;
        }).join(', ');
      },
      onChange: handleChange,
      children: displayOptions.map(function (_ref10) {
        var label = _ref10.label,
          value = _ref10.value,
          rest = _objectWithoutProperties(_ref10, _excluded2);
        return /*#__PURE__*/_jsxs(Select.Option, _objectSpread(_objectSpread({
          value: value,
          label: label,
          style: {
            position: 'relative'
          }
        }, rest), {}, {
          children: [multiple ? /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(Checkbox, {
              checked: Array.isArray(selected) && selected.includes(value),
              style: {
                marginRight: 8
              }
            }), label]
          }) : label, /*#__PURE__*/_jsx("div", {
            style: {
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 2,
              top: 0,
              left: 0
            }
          })]
        }), value);
      })
    }))
  });
};
var AttachedSelect = Object.assign(optionsHOC(IglooSelect), {
  Option: Select.Option,
  OptGroup: Select.OptGroup
});
AttachedSelect.isPreviewSupport = true;
AttachedSelect.formItemPropsHandler = function () {
  return {};
};
export default AttachedSelect;